/**
 * @fileoverview Agent definition for reference-image-creator-fal-v2.
 *
 * This agent generates images with multiple character references using FLUX 2 Pro Edit
 * for visual consistency across characters in a scene.
 *
 * @category visuals.images.story
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'reference-image-creator-fal-v2',
  kind: 'primitive',
  name: 'Reference Image Creator (FAL)',
  description: 'Generates images with multiple character references using FLUX 2 Pro Edit for visual consistency.',
  category: 'visuals',
  defaultPrompt: prompt, // No prompt needed - this is an image generation agent
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-09',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.images.story',
    usedBy: [
      'use-reference-image-creator-fal-v2.ts',
      'use-reference-generation-v2.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'reference-image-prompt-creator-v2',
      'story-image-creator-fal-v2',
    ],
  },
};
